module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2rIto"))).then(() => parcelRequire('hEqeo'));